import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { ScreeningListPage } from "@/modules/repairs/pages/ScreeningList.page";

export const Route = createFileRoute("/__authed/m/repairs/screening")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_screening")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: ScreeningListPage,
});
